var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var Svg24 = function Svg24(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.46 5.54a.65.65 0 0 1 0 .92L9.92 12l5.54 5.54a.65.65 0 1 1-.92.92l-6-6a.65.65 0 0 1 0-.92l6-6a.65.65 0 0 1 .92 0Z",
    fill: "currentColor"
  })));
};

export { Svg24 as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik0xNS40NTk2IDUuNTQwMzhDMTUuNzEzNSA1Ljc5NDIyIDE1LjcxMzUgNi4yMDU3OCAxNS40NTk2IDYuNDU5NjJMOS45MTkyMyAxMkwxNS40NTk2IDE3LjU0MDRDMTUuNzEzNSAxNy43OTQyIDE1LjcxMzUgMTguMjA1OCAxNS40NTk2IDE4LjQ1OTZDMTUuMjA1OCAxOC43MTM1IDE0Ljc5NDIgMTguNzEzNSAxNC41NDA0IDE4LjQ1OTZMOC41NDAzNyAxMi40NTk2QzguMjg2NTMgMTIuMjA1OCA4LjI4NjUzIDExLjc5NDIgOC41NDAzNyAxMS41NDA0TDE0LjU0MDQgNS41NDAzOEMxNC43OTQyIDUuMjg2NTQgMTUuMjA1OCA1LjI4NjU0IDE1LjQ1OTYgNS41NDAzOFoiIGZpbGw9ImN1cnJlbnRDb2xvciIvPgo8L3N2Zz4K";